function growtypeWc() {
    document.addEventListener('click', (event) => {
        const button = event.target.closest('.growtype-wc-checkout-button');
        if (!button) {
            return;
        }

        const productId = button.getAttribute('data-product-id');
        if (!productId) {
            return;
        }

        const configuredMethods = (
            button.getAttribute('data-methods') ||
            button.getAttribute('data-method') ||
            ''
        ).toLowerCase();

        const isExpressWalletButton =
            configuredMethods.includes('applepay') ||
            configuredMethods.includes('googlepay');

        if (!isExpressWalletButton) {
            return;
        }

        let paymentMethod = null;

        const fallbackUrl = button.getAttribute('data-fallback');
        if (fallbackUrl) {
            try {
                const parsedFallback = new URL(fallbackUrl, window.location.origin);
                paymentMethod = parsedFallback.searchParams.get('payment_method');
            } catch (error) {
                // noop
            }
        }

        if (!paymentMethod) {
            const modal = button.closest('.modal');
            const primaryMethod =
                button.getAttribute('data-primary-payment-method') ||
                (modal ? modal.getAttribute('data-primary-payment-method') : null);

            if (primaryMethod && primaryMethod.startsWith('gwc-')) {
                paymentMethod = primaryMethod;
            }
        }

        // If provider is not explicitly known, keep default payment form flow.
        if (!paymentMethod) {
            return;
        }

        // Redirect override is Stripe-only.
        if (paymentMethod !== 'gwc-stripe') {
            return;
        }

        const stripeShowFormRaw = button.getAttribute('data-stripe-express-show-form');

        // If setting is not explicitly provided, keep default payment form flow.
        if (!stripeShowFormRaw) {
            return;
        }

        const stripeShowForm = stripeShowFormRaw.toLowerCase() === 'yes';
        if (stripeShowForm) {
            return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        const params = new URLSearchParams();
        params.set('add-to-cart', productId);
        params.set('payment_method', paymentMethod);

        const returnUrl = button.getAttribute('data-return-url');
        if (returnUrl) {
            params.set('growtype_return_after_payment_url', returnUrl);
        }

        window.location.href = `/checkout/?${params.toString()}`;
    }, true);
}

export { growtypeWc };
